import { request } from './request'

// 获取安全域列表
export const getTPBizAreaList = () => request('/portal/verify/tp/jobBizAreaList')

// 获取计划任务列表
export interface GetTPPlanList {
  limit: number
  page: number
  keyword?: string
  start_time?: string
  end_time?: string
  scheduler_type?: string | number
  biz_area?: string
}
export const getTPPlanTaskList = (data: GetTPPlanList) =>
  request('/portal/verify/tp/jobList', {
    params: {
      ...data,
    },
  })

// 获取计划详情
export interface GetTPTaskDetail {
  id: string
}
export const getTPTaskDetail = (data: GetTPTaskDetail) =>
  request('/portal/verify/tp/jobDetail', {
    params: {
      ...data,
    },
  })

// 删除计划任务列表
export interface DeleteTask {
  id: string
}
export const deleteTask = (data: DeleteTask) =>
  request('/portal/verify/tp/deleteJob', {
    method: 'DELETE',
    data,
  })

// 批量删除计划任务列表
export interface BathDeleteTask {
  id_list: string[]
}
export const bathDeleteTask = (data: BathDeleteTask) =>
  request('/portal/verify/tp/batchDeleteJob', {
    method: 'DELETE',
    data,
  })

// 暂停/重启 计划任务
export interface ChangeJobStatus {
  id: string
  task_status: number
}
export const changeJobStatus = (data: ChangeJobStatus) =>
  request('/portal/verify/tp/changeJobStatus', {
    method: 'PUT',
    data,
  })
